import { call } from 'redux-saga/effects';

import { branch } from '../../../sagas/Helpers';

import * as SkipTrackBackHelpers from './helpers';

export function* skipTrackBack(action) {
  yield call(
    branch(
      SkipTrackBackHelpers.isPastSkipThreshold,
      SkipTrackBackHelpers.scrubTrackBack,
      SkipTrackBackHelpers.skipSourceBack,
    ),
    action,
  );
}
